import {
  GET_ADDON_UOM,
  GET_CART,
} from "../../database/get-stored-data";
import { SET_STORE_ADDONUOM, SET_STORE_CART } from "../../database/store-data";
import { GET_CART_COUNT } from "../../functions/funtion";
import { F_Fammily } from "../../util/config-fonts";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import { Colors } from "../../util/colors";
import { CSP } from "../../config/config";
import CartItemList from "../render-cart-item/render-drawer-cart";
import PlaceHolder from "../../pages/home/components/product-list-place-holder/product-list-place-holder";
import Alert from "../Alert";
import React from "react";
var $ = require("jquery");

export default class SummaryCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CartData: [],
      Isloading: false,
    };
  }

  async componentDidMount() {
    // let Localcart = await GET_CART();
    // if (Localcart === undefined) {
    //   Localcart = [];
    // } CartData: Localcart,
    this.setState({ Isloading: true });
  }

  render() {
    return (
      <>
        {this.state.Isloading ? (
          <div style={{ position: "relative", height: "100%" }}>
            {/* Add padding-bottom to prevent overlap */}
            <div
              style={{
                overflow: "auto",
                // marginBottom: "50px",
                // paddingBottom: "60px",
                maxHeight: "calc(100% - 60px)",
              }}
            >
              {this.props.CartData.map((rs, i) => {
                return (
                  <CartItemList
                    key={rs.PID + "SummaryCart" + i}
                    item={rs}
                    index={i}
                    NavigateToProductPage={async (item) => {
                      if (CSP === "AV" && item.PID === 1224929) {
                        return;
                      } else {
                        await this.props.ItemClick(item);
                      }
                    }}
                    RemoveItemFromCart={async (
                      i,
                      LineID,
                      AddonLineId,
                      item
                    ) => {
                      if (CSP === "AV" && item.PID === 1224929) {
                        return;
                      } else {
                        await this.Delete(i, LineID, AddonLineId);
                      }
                    }}
                  />
                );
              })}
            </div>
            {this.props.CartData.length === 0 ? (
              <p>No data found</p>
            ) : (
              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "100%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "16px",
                }}
                onClick={async () => {
                  // var CSID = await Get_CustomerCSID();
                  // let isFromPOS = ENCRYPT_STORAGE.getItem(FROM);
                  // if (isFromPOS === "QR" && (CSID === 0 || CSID === undefined)) {
                  //   this.props.navigate(PT_SIGNIN);
                  // } else {
                    this.props.navigate(PT_CART);
                  // }
                }}
              >
                Go To Checkout
              </button>
            )}
          </div>
        ) : (
          <PlaceHolder />
        )}
      </>
    );
  }

  async Delete(i, LineID, AddonLineId) {
    let dataCart = [...this.props.CartData];
    let PID = dataCart[i].LineID;
    let ProductName = dataCart[i].Desc;
    if (LineID !== PID) {
      return;
    }

    let LocalCart = await GET_CART();
    if (LocalCart === undefined || LocalCart.length === 0) {
      return;
    }

    const deleteItem = async () => {
      this.props.closeFunction();
      let ADDonUOMList = await GET_ADDON_UOM();
      dataCart.splice(i, 1);

      if (ADDonUOMList !== undefined) {
        if (ADDonUOMList.length > 0 && ADDonUOMList !== undefined) {
          for (var k = 0; k < ADDonUOMList.length; k++) {
            if (AddonLineId === ADDonUOMList[k].LINEID) {
              ADDonUOMList.splice(k, 1);
            }
          }
        }
      }
      if (dataCart.length > 0) {
        for (var j = 0; j < dataCart.length; j++) {
          dataCart[j].LineID = j + 1;
        }
      }
      await SET_STORE_CART(dataCart);
      await SET_STORE_ADDONUOM(ADDonUOMList);
      this.setState({ CartData: dataCart });
      if (typeof this.props.onCartUpdated === "function") {
        this.props.onCartUpdated([...dataCart]);
      }
      await GET_CART_COUNT();
      let lbl = document.getElementById("viewBasketCount");
      if (lbl) {
        let cart = await GET_CART();
        if (cart === undefined) {
          $("#viewBasketCount").html(0);
        } else {
          $("#viewBasketCount").html(cart.length);
        }
      }
    };

    if (CSP !== "AV") {
      await deleteItem();
      return;
    }

    Alert.ConfirmationMessageBox({
      ConfirmButtonFunction: deleteItem,
      ConfirmButtonText: "Yes",
      DismissButtonFunction: () => {},
      Icon: "info",
      Text:
        "Do you want to remove <b>" +
        ProductName +
        "</b> from your cart?" +
        "</div>",
      Tittle: "",
    });
  }
}
